var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.51863 8.59629L1.06836 16.5043C1.06864 16.5059 1.0692 16.5072 1.06946 16.5089C1.29796 17.3676 2.08229 17.9999 3.01312 17.9999C3.38523 17.9999 3.73458 17.8993 4.03419 17.7227L4.05798 17.7088L12.4446 12.8693L8.51863 8.59629Z",
    fill: "#EB3131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0588 7.24991L16.0516 7.24502L12.4308 5.146L8.35156 8.77591L12.445 12.8688L16.0467 10.7907C16.6781 10.4498 17.1068 9.78412 17.1068 9.01647C17.1068 8.25433 16.684 7.59192 16.0588 7.24991Z",
    fill: "#F6B60B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06833 1.49512C1.02354 1.66028 1 1.83328 1 2.01293V15.987C1 16.1663 1.02326 16.3399 1.06861 16.5045L8.77608 8.79861L1.06833 1.49512Z",
    fill: "#5778C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57428 8.99999L12.4308 5.14464L4.05358 0.287634C3.74908 0.105256 3.39369 0 3.0134 0C2.08257 0 1.29718 0.633435 1.06864 1.49315L1.06836 1.4953L8.57428 8.99999Z",
    fill: "#3BAD49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e07fde73ec666cc2e558c259f98d2ddf.svg";
export { ForwardRef as ReactComponent };